import { render, staticRenderFns } from "./sales_history_loader.vue?vue&type=template&id=5a730f92&scoped=true&"
import script from "./sales_history_loader.vue?vue&type=script&lang=js&"
export * from "./sales_history_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a730f92",
  null
  
)

export default component.exports